export const roundToNDecimals = (value: number, decimals: number = 1) =>
  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);

export const isNumeric = (n: any) => {
  if (typeof n === "string") {
    if (n === "0") {
      return true;
    }

    if (Number.isInteger(parseFloat(n))) {
      return (
        !isNaN(parseFloat(n)) &&
        isFinite(n as any) &&
        n.toString().indexOf("0") !== 0
      );
    }

    return !isNaN(parseFloat(n)) && isFinite(n as any);
  }

  return !isNaN(parseFloat(n)) && isFinite(n);
};

export const convertStringToFloat = (
  value: string | undefined
): number | undefined => {
  const parsed = Number(value);

  return !isNaN(parsed) ? parsed : undefined;
};
